import React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import {Icon} from '@/components/atoms';

const SingleDateCustomInput = React.forwardRef(
  (
    {
      value = '',
      onClick,
      column,
      sx,
      singleDates,
      setOpenDatePicker,
      className = ''
    },
    ref
  ) => {
    if (!column?.name_of_db_column) return null;

    const selectedDate = singleDates[column.name_of_db_column];
    const showCross = selectedDate != null;
    const showCalendar = !showCross;

    const fallbackLabel = value || column.label_of_column;
    const buttonText = selectedDate
      ? `${selectedDate.toLocaleDateString()}`
      : fallbackLabel;

    return (
      <Button
        ref={ref}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setOpenDatePicker(column.name_of_db_column);
          onClick?.(e);
        }}
        variant='outlined'
        size='small'
        fullWidth
        className={`${className} date-button-input ${showCalendar ? 'is-placeholder' : ''}`}
        sx={{...sx, textTransform: 'none'}}>
        <div
          className='date-button-content'
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%'
          }}>
          <div className='date-button-text' style={{fontSize: '12px'}}>
            {buttonText}
          </div>
          {showCalendar ? <Icon icon='calendar_today' size='small' /> : null}
        </div>
      </Button>
    );
  }
);

SingleDateCustomInput.propTypes = {
  value: PropTypes.string,
  onClick: PropTypes.func,
  column: PropTypes.shape({
    name_of_db_column: PropTypes.string.isRequired,
    label_of_column: PropTypes.string
  }).isRequired,
  sx: PropTypes.object,
  singleDates: PropTypes.object.isRequired,
  setOpenDatePicker: PropTypes.func.isRequired,
  className: PropTypes.string
};

export default SingleDateCustomInput;
